var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Portlet',{attrs:{"title":"Inbox","icon":"envelope-open"}},[_c('Inbox',{attrs:{"note-id":_vm.noteId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }